import { ButtonHTMLAttributes } from "react";
import { PopoverClose } from "../../popover";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faCircle,
  faCircleCheck,
} from "@fortawesome/free-regular-svg-icons";
import {
  faMagic,
  faMagicWandSparkles,
} from "@fortawesome/free-solid-svg-icons";

import MagicIcon from "../../../assets/magic_icon.png";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary";
  label: string | JSX.Element;
  onClick: () => void;
  status: "active" | "ready" | "magic";
}

export const DumbDropdownButtonOption = ({
  variant = "secondary",
  className,
  label,
  onClick,
  children,
  status,
  ...props
}: Props) => {
  const getButtonSubtitle = () => {
    if (status === "active") {
      return "Active";
    } else if (status === "ready") {
      return "Ready";
    } else if (status === "magic") {
      return "Ready to translate";
    }
    return "Unknown";
  };

  const getIcon = () => {
    if (status === "active") {
      return (
        <FontAwesomeIcon
          icon={faCheckCircle}
          className="text-black"
          width={24}
          height={24}
        />
      );
    } else if (status === "ready") {
      return (
        <FontAwesomeIcon
          icon={faCircle}
          className="text-black"
          width={24}
          height={24}
        />
      );
    } else if (status === "magic") {
      return <img src={MagicIcon} alt="Magic Icon" className="w-6 h-6" />;
    }

    return (
      <FontAwesomeIcon
        icon={faCircle}
        className="text-black"
        width={24}
        height={24}
      />
    );
  };

  return (
    <PopoverClose asChild>
      <button
        className="flex items-center rounded-lg py-1 hover:bg-gray-100 pointer-events-auto"
        onClick={onClick}
        style={{ cursor: "pointer" }}
      >
        <div className="flex flex-row justify-center items-center p-1">
          {getIcon()}
          <div className="flex flex-col items-start pl-1">
            <span
              className="text-sm text-black"
              style={{ pointerEvents: "auto", cursor: "pointer" }}
            >
              {label}
            </span>
            <span className="text-sm text-gray-6">{getButtonSubtitle()}</span>
          </div>
        </div>
      </button>
    </PopoverClose>
  );
};
